import type { Campaign } from 'c-sdk';

/**
 * Does this campaign use insertion-order targeting? Then its schedule page manages insertion orders
 * (rules, schedules, the allowed venue list) rather than displays, and it has no hand-typed IO ids.
 *
 * `vistar_us2` is the permanent targeting type. `vistar_us` is the legacy type and must look and
 * work exactly as before. This mirrors the API's `Campaign::usesInsertionOrderTargeting()`: change
 * both together, and test for the type only through this function.
 */
export const usesInsertionOrderTargeting = (campaign?: Pick<Campaign, 'type'> | null): boolean =>
    campaign?.type === 'vistar_us2';
